function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M16.08 18.882A8 8 0 014 12l1.033-.688L6 12a6 6 0 009.06 5.163l1.02 1.72zm.62-8.346l2.328 2.331 2.252-2.32 1.435 1.393-3.666 3.777-3.764-3.767 1.415-1.414zM7.937 5.107A8 8 0 0120 12l-.982 1.045L18 12a6 6 0 00-9.046-5.17L7.937 5.106zM2.7 13.717l-1.415-1.413 3.764-3.768 3.666 3.778-1.435 1.393-2.252-2.32-2.328 2.33z"
});
function SvgRefresh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), _ref);
}
export default SvgRefresh;